export default "__VITE_ASSET__c8676981__"